import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export default function CustomRadioButton({ checked, onChange, className, label, name, id }) {
  return (
    <label className={classnames('custom-radio-button', className, { 'custom-radio-button--checked': checked })}>
      <input
        type="radio"
        className="custom-radio-button__input"
        checked={checked}
        onChange={onChange}
        name={name}
        id={id}
      />

      <span className="custom-radio-button__box">
        <span className="custom-radio-button__dot" />
      </span>

      {label ? <span className="custom-radio-button__label">{label}</span> : null}
    </label>
  )
}

CustomRadioButton.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
}
